import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1e3a8a] text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo y descripción */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_morabio-web/artifacts/o1ie7x5d_LogoMoraBioNegro.jpg" 
              alt="MoraBioVet" 
              className="h-16 w-auto bg-black p-2 rounded"
            />
            <p className="text-gray-300 text-sm">
              Laboratorio veterinario donde cada resultado protege una vida.
            </p>
            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300 transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Enlaces rápidos */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li>
                <Link to="/estudios" className="hover:text-white transition-colors">
                  Estudios
                </Link>
              </li>
              <li>
                <Link to="/sucursales" className="hover:text-white transition-colors">
                  Sucursales
                </Link>
              </li>
              <li>
                <Link to="/promociones" className="hover:text-white transition-colors">
                  Promociones
                </Link>
              </li>
              <li>
                <Link to="/resultados" className="hover:text-white transition-colors">
                  Resultados
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Información */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Información</h3>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li>
                <Link to="/acerca-de" className="hover:text-white transition-colors">
                  Acerca de nosotros
                </Link>
              </li>
              <li>
                <Link to="/terminos" className="hover:text-white transition-colors">
                  Términos y condiciones
                </Link>
              </li>
              <li>
                <Link to="/privacidad" className="hover:text-white transition-colors">
                  Política de privacidad
                </Link>
              </li>
              <li>
                <Link to="/aviso-privacidad" className="hover:text-white transition-colors">
                  Aviso de privacidad
                </Link>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contacto</h3>
            <ul className="space-y-3 text-gray-300 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span>Cenzontle 137, Palo Solo, Huixquilucan de Degollado, Estado de México</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-5 w-5 flex-shrink-0" />
                <a href="tel:5545547772" className="hover:text-white transition-colors">
                  554-554-7772
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-5 w-5 flex-shrink-0" />
                <span>info@morabiovet.com</span>
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-sm mb-2">Horario de atención:</p>
              <p className="text-gray-300 text-xs">
                Lunes a Viernes: 8:00 AM - 7:00 PM<br />
                Sábados: 9:00 AM - 2:00 PM
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-400 text-sm">
          <p>&copy; 2026 MoraBioVet. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;